export default __webpack_public_path__ + "static/media/usuario.178d03ca.png";